module.exports = __webpack_public_path__ + "static/img/img_logo.0cd72e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_logo.png
// module id = PcyW
// module chunks = 9